import TrajectoryControlStyle from "./TrajectoryControl.module.scss";
import  * as React from "react";
import { observer } from "mobx-react";
import {ITrajectoryControlParams} from "./ITrajectoryControlParams";
import { TrajectoryBackground } from "./../TrajectoryControl/TrajectoryBackground/TrajectoryBackground";
import {ReportKind} from "Data";

@observer
export class TrajectoryControl extends React.Component<ITrajectoryControlParams>{
    constructor(props: ITrajectoryControlParams) {
        super(props, undefined);
    }


    isReportAppropriate(): boolean {
        return this.props.reportKind === ReportKind.multiGroupReport
            || this.props.reportKind === ReportKind.singleGroupReport
            || this.props.reportKind === ReportKind.puttingMultiGroupReport
            || this.props.reportKind === ReportKind.puttingSingleGroupReport
            || this.props.reportKind === ReportKind.combineTestReport
            || this.props.reportKind === ReportKind.testCenterReport;
    }

    render() {
        if (!this.props.measurementsData)
            return <div></div>;
        return <div className={TrajectoryControlStyle.TrajectoryControl}>
            {this.isReportAppropriate() && this.props.selectedStrokesGroups.length === 0 &&
                <div className={TrajectoryControlStyle.infoContainer}>
                    <p>You have no groups selected.</p>
                    <p>Select a group and a shot to activate the trajectory view.</p>
                </div>
            }
            {this.props.selectedStroke && (this.props.selectedStroke.trajectory == null || this.props.selectedStroke.trajectory.length === 0) &&
                <div className={TrajectoryControlStyle.infoContainer}>
                    <p>There is no trajectory to display.</p>
                </div>
            }
            <div id="trajectory-container" className={TrajectoryControlStyle.trajectorySide}>
                <div>
                    <TrajectoryBackground 
                        storageDataMultipleTrajectories={this.props.measurementsData} 
                        unitPresentation={this.props.unitPresentation} 
                        selectedStroke={this.props.selectedStroke} 
                        selectedAverage={this.props.selectedAverage} 
                        selectedGroupOfStrokes={this.props.selectedGroupOfStrokes} 
                        onSelectStroke={this.props.onSelectStroke} 
                        onCleanSelectedShot={this.props.onCleanSelectedShot} 
                        reportKind={this.props.reportKind}/>
                </div>
            </div>
        </div >;
    }
}
